

import React, { useState, useEffect } from 'react';
import { Monitor, BookOpen, GraduationCap, Briefcase, Globe, Book } from 'lucide-react';
import { CheckCircle } from "lucide-react";

const whatsappLeadsData = [
  {
    heading: "Chat with Students via WhatsApp Ads",
    points: [
      "Use click-to-WhatsApp ads to connect with students instantly.",
      "Capture high-intent leads from platforms like Facebook.",
      "Boost conversions with 90% open rates vs. 20% for email.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_2.png",
  },
  {
    heading: "Turn Website Visitors into Leads",
    points: [
      "Add WhatsApp widgets to landing pages for instant chats.",
      "Engage event attendees with real-time WhatsApp support.",
      "Convert traffic into leads with seamless messaging.",
    ],
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_3.png",
  },
  {
    heading: "Retarget Students Cost-Effectively",
    points: [
      "Reach website visitors on WhatsApp for just 90 paise per message.",
      "Get your promotions noticed with high visibility.",
      "Cut costs while driving 50% higher engagement than ads.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_4.png",
  },
  {
    heading: "Shine at Education Fairs",
    points: [
      "Use QR codes to start WhatsApp chats at fairs.",
      "Capture attendee details on the spot.",
      "Follow up instantly to keep the conversation going.",
    ],
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_5.png",
  },
  {
    heading: "Grow Leads with Free Content",
    points: [
      "Share free educational resources via WhatsApp.",
      "Collect contact info to build your lead list.",
      "Engage students with content they’ll love.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_6.png",
  },
  {
    heading: "Kick Off with Personal Chats",
    points: [
      "Send warm, tailored welcome messages on WhatsApp.",
      "Make every student feel special from day one.",
      "Set the stage for lasting engagement.",
    ],
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_7.png",
  },
  {
    heading: "Smart Messaging for Every Student",
    points: [
      "Group leads by interests for targeted chats.",
      "Send messages that hit the mark every time.",
      "Boost responses with relevant follow-ups.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_8.png",
  },
  {
    heading: "Engage with Fun Content",
    points: [
      "Share quizzes and surveys via WhatsApp.",
      "Learn what students want while keeping them hooked.",
      "Turn chats into interactive experiences.",
    ],
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_9.png",
  },
  {
    heading: "Guide Students Step-by-Step",
    points: [
      "Start easy WhatsApp journeys for new leads.",
      "Share key info in bite-sized chats.",
      "Keep students moving toward enrollment.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_10.png",
  },
  {
    heading: "Spark Interest with Early Offers",
    points: [
      "Send webinar invites or trial class offers.",
      "Grab attention with exclusive deals.",
      "Get students engaged fast with ChatMitra.",
    ],
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_11.png",
  },
  {
    heading: "Hassle-Free Document Collection",
    points: [
      "Use WhatsApp chatbots to gather documents.",
      "Make paperwork quick and painless.",
      "Confirm submissions in real-time.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_12.png",
  },
  {
    heading: "Smooth Enrollment Made Simple",
    points: [
      "Guide students through enrollment with WhatsApp.",
      "Offer live help for a stress-free process.",
      "Cut delays with automated updates.",
    ],
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_13.png",
  },
  {
    heading: "Warm Welcome Orientation",
    points: [
      "Host virtual orientations via WhatsApp.",
      "Share schedules and FAQs with ease.",
      "Make new students feel right at home.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_14.png",
  },
  {
    heading: "Easy Course Registration",
    points: [
      "Help students pick courses via WhatsApp.",
      "Highlight deadlines and options clearly.",
      "Answer questions instantly with ChatMitra.",
    ],
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_15.png",
    
  },
  {
    heading: "Keep Students Connected",
    points: [
      "Check in regularly with WhatsApp messages.",
      "Ask for feedback to improve their experience.",
      "Build a community with ongoing chats.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_16.png",
  },
];

const services = [
  { icon: <Monitor size={48} color="#075E54" />, title: "Training Institutes", description: "Run admissions and chats across locations with WhatsApp ease." },
  { icon: <BookOpen size={48} color="#075E54" />, title: "EdTech", description: "Keep students active on your platform with fast WhatsApp replies." },
  { icon: <GraduationCap size={48} color="#075E54" />, title: "Universities", description: "Connect everyone—from applicants to alumni—with WhatsApp." },
  { icon: <Briefcase size={48} color="#075E54" />, title: "Career Schools", description: "Track every student detail smoothly via WhatsApp." },
  { icon: <Globe size={48} color="#075E54" />, title: "Overseas Education", description: "Support global students with WhatsApp updates." },
  { icon: <Book size={48} color="#075E54" />, title: "Higher Education", description: "Turn admissions chats into welcomes with WhatsApp." },
];

const Educationcycle = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => setIsVisible(true), []);

  return (
    <>
      <div className="flex flex-col justify-center items-center text-center h-52 sm:h-64 md:h-72 lg:h-80 px-6 py-4 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-300 shadow-lg rounded-lg">
        <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold leading-tight max-w-4xl text-gray-900">
          Master the Student Journey with WhatsApp for Education
        </h1>
        <div className="w-16 h-1 bg-gray-600 my-4 rounded-full"></div>
        <p className="text-sm sm:text-lg md:text-xl text-gray-800 max-w-3xl mt-2 md:mt-4 px-2">
          Cut costs and boost engagement with ChatMitra’s WhatsApp tools—perfect for every step of the student lifecycle.
        </p>
      </div>
      <div className="flex flex-col gap-20 sm:gap-20 bg-white max-w-6xl mx-auto mt-10 mb-10 px-4 sm:px-0">
        {whatsappLeadsData.map((item, index) => (
          <section
            key={index}
            className={`flex flex-col md:flex-col lg:flex-row items-center justify-between gap-16 sm:gap-20 ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}
          >
            <div className="lg:w-1/2 md:w-full flex justify-center mb-4 lg:mb-0">
              <img
                src={item.image}
                alt={`${item.heading} with ChatMitra`}
                className="max-w-full h-auto rounded-lg border-transparent transition-all duration-500"
              />
            </div>
            <div className="w-full md:w-full lg:w-1/2 text-left md:p-5">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 leading-tight">{item.heading}</h2>
              <ul className="mt-6 space-y-4 text-lg text-gray-700">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start space-x-3">
                    <CheckCircle className="text-[#075E54] w-4 h-4 self-center flex-shrink-0" strokeWidth={3} />
                    <span className="leading-relaxed">{point}</span>
                  </li>
                ))}
              </ul>
              {item.buttonText && (
               <a
               href={item.buttonLink}
               className="mt-6 inline-block bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors"
             >
               {item.buttonText}
             </a>
              )}
            </div>
          </section>
        ))}
      </div>
      <div className="bg-[#075E54] min-h-screen w-full flex items-center justify-center py-12 px-4">
        <div className="max-w-6xl w-full">
          <div className="flex flex-col justify-center items-center text-center px-6 py-4">
            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold leading-tight max-w-5xl text-white">
              Reach Students Where They Are—With WhatsApp
            </h1>
            <div className="w-16 h-1 bg-white my-4 rounded-full"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <div
                key={index}
                className={`bg-white rounded-lg p-6 shadow-lg transition-all duration-500 transform hover:shadow-xl hover:-translate-y-1 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="mb-4">{service.icon}</div>
                <h3 className="text-xl font-bold mb-2">{service.title}</h3>
                <p className="text-gray-700">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center bg-[#128C7E] min-h-[300px] px-4 py-8 relative overflow-hidden">
        <div className="bg-white rounded-lg shadow-xl max-w-6xl w-full mx-auto p-6 justify-center">
          <div className="text-center mb-4 justify-center">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-black leading-tight">
              Ready to Transform Education with WhatsApp?
            </h1>
            <p className="text-base sm:text-lg text-black leading-relaxed mt-3 max-w-3xl mx-auto text-center">
              Book a demo and see how ChatMitra makes student engagement and communication a breeze.
            </p>
          </div>
          <div className="flex justify-center mb-6">
            <div className="relative">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-12 w-12 text-[#075E54]"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.520-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              <div className="absolute -top-2 -right-2 w-5 h-5 bg-[#075E54] rounded-full flex items-center justify-center text-white text-xs font-bold">
                1
              </div>
            </div>
          </div>
          <div className="flex justify-center">
            <button className="text-base sm:text-lg text-white bg-[#075E54] px-6 py-3 rounded-full hover:bg-[#1faa50] transition duration-300 flex items-center shadow-lg group">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
              <span>Schedule a Call</span>
              <div className="ml-2 w-px h-4 bg-white/50"></div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform duration-300"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Educationcycle;